import type { MeldBericht, MeldingRegel } from './types';

/** P5: poll only while the panel is open, every 5 s, for at most 3 minutes. */
export const POLL_MS = 5_000;
export const POLL_MAX_MS = 180_000;
/** P7: "Nog steeds kapot" on meldingen solved at most 30 days ago. */
export const NOG_KAPOT_DAGEN = 30;

export function pollInterval(sinds: number, nu: number): number | false {
  return nu - sinds < POLL_MAX_MS ? POLL_MS : false;
}

export function openAiVraag(berichten: readonly MeldBericht[]): MeldBericht | null {
  for (let i = berichten.length - 1; i >= 0; i -= 1) {
    const b = berichten[i];
    if (!b) continue;
    if (b.van === 'klant') return null;
    if (b.van === 'ai' && b.soort === 'vraag') return b;
  }
  return null;
}

export function magNogKapot(m: MeldingRegel, nu: Date): boolean {
  if (m.stand !== 'opgelost' || !m.opgelost_op) return false;
  const op = Date.parse(m.opgelost_op);
  return Number.isFinite(op) && nu.getTime() - op <= NOG_KAPOT_DAGEN * 86_400_000;
}
